import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import Vue from 'vue';

import { AgGridVue } from 'ag-grid-vue';
Vue.component('ag-grid-vue', AgGridVue);
